<template>
  <div>
    <div>

      <instCheckBox :fieldName="'AGREEMENT_EASY_DRAFT_IU'">
        <template v-slot:content>
          <p>
            Я ознакомлен и согласен со
            <a href="" v-on:click="agreementVisibleToggle">следующим</a>
          </p>
        </template>
      </instCheckBox>

    </div>
    <div v-show="agreementVisible" class="agreementDesc">
      <instCheckBox :fieldName="'AGREEMENT_IU'">
        <template v-slot:content>
          <p>Индивидуальные условия <a :href="uiUrl" target="_blank">Открыть документ</a></p>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'AGREEMENT_PDN'">
        <template v-slot:content>
          <p>Согласие ПДН <a :href="pdnUrl" target="_blank">Открыть документ</a></p>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'AGREEMENT_ANKETA'">
        <template v-slot:content>
          <p>Заявление-анкета заемщика <a :href="anketaUrl" target="_blank">Открыть документ</a></p>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'AGREEMENT_RECURENT'"></instCheckBox>


      <instAbsoluteBox v-if="hasAbsoluteBox" />
      <instFimollCareBox v-if="hasFimollCareBox" />


      <div>
        <p><b>Правовая информация</b></p>
        <div id="legalBoxDesc">
          <p>В случае, если в таблице «Информация об услугах третьих лиц» мною проставлена отметка рядом с услугой,
            прошу перечислить часть займа в размере, составляющем стоимость дополнительной услуги, третьему лицу,
            предоставляющему соответствующую услугу. Я подтверждаю, что правила оказания услуг третьими лицами мне
            разъяснены и мною получены. Я уведомлен о том, что правила оказания третьими лицами услуг доступны в Личном
            кабинете заемщика. Я уведомлен о том, что приобретение услуг третьего лица не влияет на решение кредитора о
            предоставлении мне займа и на его условия. Я уведомлен о моем праве отказаться от услуги третьего лица в
            течение 30 календарных дней со дня выражения мною согласия на ее оказание посредством обращения к третьему
            лицу, оказывающему дополнительную услугу, с заявлением об отказе от такой услуги. Я также уведомлен, что
            вправе требовать от лица, оказывающего дополнительную услугу, возврата денежных средств, уплаченных за
            оказание такой услуги, за вычетом стоимости части такой услуги, фактически оказанной мне до дня получения
            лицом, оказывающим такую услугу, моего заявления об отказе от такой услуги. В случае, если третье лицо не
            исполняет обязанность по возврату мне денежных средств при отказе от дополнительной услуги, я вправе
            обратиться в ООО МКК «ФИНМОЛЛ» с заявлением о возврате денежных средств при отказе от дополнительной
            услуги.</p>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instAgreement_easyconfirm",
  data() {
    return {
      agreementVisible: false,
      uiUrl: 'https://lk.msk.finmoll.com/public/confirm?request=' + localStorage.getItem('GUIDeasyConf'),
      pdnUrl: 'https://lk.msk.finmoll.com/public/pdnIl/' + localStorage.getItem('GUIDeasyConf'),
      anketaUrl: 'https://lk.msk.finmoll.com/public/pdnIl/' + localStorage.getItem('GUIDeasyConf'),
    }
  },
  components: {
    instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
    instAbsoluteBox: () => import('@/components/inst/instAbsoluteBox.vue'),
    instFimollCareBox: () => import('@/components/inst/instFimollCareBox.vue'),
  },
  methods: {
    agreementVisibleToggle($event) {
      $event.preventDefault();
      this.agreementVisible = !this.agreementVisible;
    },
    cdAGREEMENT_ALL(value) {
      this.$store.dispatch('saveSendData', {
        target: 'AGREEMENT_EASY_DRAFT_IU',
        value: value
      });
    }
  },
  computed: {
    ...mapState({
      boxArr: state => state.instForm.boxArr,
      AGREEMENT_EASY_DRAFT_IU: state => state.Form.sendData.AGREEMENT_EASY_DRAFT_IU,
      AGREEMENT_PDN: state => state.Form.sendData.AGREEMENT_PDN,
      AGREEMENT_IU: state => state.Form.sendData.AGREEMENT_IU,
      AGREEMENT_ANKETA: state => state.Form.sendData.AGREEMENT_ANKETA,
      AGREEMENT_RECURENT: state => state.Form.sendData.AGREEMENT_RECURENT,
    }),
    hasAbsoluteBox() {
      return this.boxArr.some(item => item.Id === 4);
    },
    hasFimollCareBox() {
      return this.boxArr.some(item => item.Id === 3);
    },
  },
  watch:{
    AGREEMENT_EASY_DRAFT_IU(newValue){
      if(newValue) {
        const arrFields = ['AGREEMENT_IU','AGREEMENT_PDN','AGREEMENT_ANKETA','AGREEMENT_RECURENT'];
        arrFields.forEach(item=>{
          this.$store.dispatch('saveSendData', {
            target: item,
            value: newValue
          });
        })
      }
    },
    AGREEMENT_IU(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_PDN && this.AGREEMENT_ANKETA && this.AGREEMENT_RECURENT){
        this.cdAGREEMENT_ALL(true);
      }
    },
    AGREEMENT_PDN(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_IU && this.AGREEMENT_ANKETA && this.AGREEMENT_RECURENT){
        this.cdAGREEMENT_ALL(true);
      }
    },
    AGREEMENT_ANKETA(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_IU && this.AGREEMENT_PDN && this.AGREEMENT_RECURENT){
        this.cdAGREEMENT_ALL(true);
      }
    },
    AGREEMENT_RECURENT(newValue){
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.AGREEMENT_IU && this.AGREEMENT_PDN && this.AGREEMENT_ANKETA){
        this.cdAGREEMENT_ALL(true);
      }
    },
  }
}
</script>

<style scoped>
.agreementDesc{margin-left: var(--font-size-10)}
#legalBoxDesc {
  width: 85%;
  height: 30vh;
  overflow: scroll;
  padding: var(--font-size-05);
  background: var(--color-gray-type2);
  font-size: var(--font-size-13);
  margin-top: var(--font-size-10)
}
</style>